// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import HistoricalEconomicsGoogleChartGraphics from '../../components/HistoricalEconomics/HistoricalEconomicsGoogleChartGraphics.js';

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postSendBillingInfo = endpointHelias+'/Helias/V0/Messaging/postSendBillingInfo'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")

// HELIAS ANALYTICS
const HistoricalEconomics = (params) => {

  useEffect(() => {      
    console.log("Gráfica histórico Economía cargada correctamente.")      
  }, [params.update]);

  function enviarFactura(fechaFactura){
      
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
  
    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
        
    //Petición de datos 
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId"),
      "billingDate": fechaFactura
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postSendBillingInfo, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)
  
        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          
          //Si recibo datos ya configurados lo cargo  
  
          initialConfigCommonJS.mostrarMensajeInformativo("Resumen enviado correctamente, revisa tu correo electrónico.","positive")        
          console.log("Factura enviada correctamente.")
          
        }
  
        document.getElementById("loaderGeneralAplicacion").className="loader hidden"
  
      }
  
      if (this.readyState === 4 && this.status !== 200) {   
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
      }
    }
    xhttp.send(data); 
  
  }

  return ( 
    
    <div className="modal-content full-width">
      <button className="link close" onClick={() => params.operarDetalleLateralPantallaCompleta("cerrar")}><span className="material-icon">highlight_off</span></button>
      <div className="page wrapper fill">      

        <section id="historicalAnalytics" className="vertical gap-04 fill" >

        <h1 className="headline-02">Histórico económico</h1>       

          <div id="botoneraPrincipal" className="content-wrapper" >

            <fieldset id="componenteEnvioFactura" >
              <legend>¿Necesitas el resumen de algún mes?</legend>

              <fieldset className="horizontal gap-04"> 

                  <fieldset className="dropdown fill"> 
                      <div className="icon-wrapper">
                      <select id="selectFechaFactura">                                            
                      </select> 
                      </div>
                  </fieldset>
                  
                  <button id="botonContinuar" className="button primary" onClick={() => enviarFactura(document.getElementById("selectFechaFactura").value)}>Enviar</button>
              
              </fieldset>
            </fieldset>

          </div>        

          <div className='chart-wrapper'>
            <HistoricalEconomicsGoogleChartGraphics graphicId={"graficaHistoricalEconomics"} /> 
          </div>

        </section>

      </div>
    </div>
  )
}

export default HistoricalEconomics